<template>
  <el-dialog
    :title="dialogTitle"
    :close-on-click-modal="false"
    :visible.sync="visible"
    class="dialog_"
    @close="handleClose"
    top="4vh"
    width="60%"
  >
    <el-form
      v-loading="loading"
      ref="formDataRef"
      :model="formData"
      :rules="formRules"
      label-width="140px"
      label-position="right"
      style="padding: 8px 0 0 0"
    >
      <div class="base-info">
        <el-divider content-position="left">基本信息</el-divider>
        <div class="content">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="realName" label="姓名" disabled>
                <el-input v-model="formData.realName" disabled placeholder="-" />
              </el-form-item>
              <el-form-item prop="sex" label="性别">
                <el-radio-group v-model="formData.sex" disabled>
                  <el-radio value="男">男</el-radio>
                  <el-radio value="女">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="headImage" label="照片">
                <el-image :src="formData.headImage" fit="cover" style="width: 120px; height: 150px" />
              </el-form-item>
              <el-form-item prop="idNum" label="身份证">
                <el-input v-model="formData.idNum" placeholder="-" disabled />
              </el-form-item>
              <el-form-item prop="age" label="年龄">
                <el-input v-model="formData.age" placeholder="-" disabled />
              </el-form-item>
              <el-form-item prop="birthday" label="生日">
                <el-date-picker v-model="formData.birthday" disabled type="date" value-format="YYYY-MM-DD" placeholder="-" />
              </el-form-item>
              <el-form-item prop="nation" label="民族" disabled>
                <el-input v-model="formData.nation" placeholder="-" />
                <!-- <el-select v-model="formData.nation" placeholder="-" style="width: 240px">
                  <el-option v-for="(item, index) in nationOptions" :key="index" :label="item" :value="item" />
                </el-select> -->
              </el-form-item>
              <el-form-item prop="navitePlace" label="籍贯" >
                <el-input v-model="formData.navitePlace" disabled placeholder="-" />
                <!-- <el-select v-model="formData.navitePlace" placeholder="-" style="width: 240px">
                  <el-option v-for="(item, index) in educationOptions" :key="index" :label="item" :value="item" />
                </el-select> -->
              </el-form-item>
              <el-form-item prop="navite" label="出生地">
                <el-input disabled v-model="formData.navite" placeholder="-" />
              </el-form-item>
              <el-form-item prop="liveCity" label="户籍地址">
                <el-input v-model="formData.liveCity" disabled placeholder="-" />
              </el-form-item>
              <el-form-item prop="residentialAddress" label="户籍地详细地址">
                <el-input
                  type="textarea"
                  disabled
                  :autosize="{ minRows: 3, maxRows: 5 }"
                  v-model="formData.residentialAddress"
                  placeholder="-"
                />
              </el-form-item>
              <el-form-item prop="address" label="居住地址">
                <el-input v-model="formData.address" disabled placeholder="-" />
              </el-form-item>
              <el-form-item prop="addressDetails" label="居住地详细地址">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5 }"
                  v-model="formData.addressDetails"
                  placeholder="-"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="maritalStatus" label="婚姻状况">
                <el-radio-group v-model="formData.maritalStatus" disabled>
                  <el-radio value="未婚">未婚</el-radio>
                  <el-radio value="已婚">已婚</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="politic" label="政治面貌">
                <el-input v-model="formData.politic" placeholder="-" disabled />
                <!-- <el-select v-model="formData.politic" placeholder="-" style="width: 240px">
                  <el-option v-for="(item, index) in politicOptions" :key="index" :label="item" :value="item" />
                </el-select> -->
              </el-form-item>
              <el-form-item prop="email" label="电子邮箱">
                <el-input v-model="formData.email" placeholder="-" disabled />
              </el-form-item>
              <el-form-item prop="phoneNum" label="手机号码">
                <el-input v-model="formData.phoneNum" placeholder="-" disabled />
              </el-form-item>
              <el-form-item prop="score" label="统考成绩">
                <el-input v-model="formData.score" placeholder="-" disabled />
              </el-form-item>
              <el-form-item prop="education" label="学历">
                <el-input v-model="formData.education" placeholder="-" disabled />
                <!-- <el-select v-model="formData.education" placeholder="-" style="width: 240px">
                  <el-option v-for="(item, index) in educationOptions" :key="index" :label="item" :value="item" />
                </el-select> -->
              </el-form-item>
              <el-form-item prop="education" label="学历类型">
                <el-input v-model="formData.educationType" placeholder="-" disabled />
                <!-- <el-select v-model="formData.educationType" placeholder="-" style="width: 240px">
                  <el-option v-for="(item, index) in educationTypeOptions" :key="index" :label="item" :value="item" />
                </el-select> -->
              </el-form-item>
              <el-form-item prop="freshStudent" label="是否为应届毕业生">
                <el-radio-group v-model="formData.freshStudent" disabled>
                  <el-radio value="否">否</el-radio>
                  <el-radio value="是">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="rewardPunish" label="受过何种奖励处分">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5 }"
                  v-model="formData.rewardPunish"
                  placeholder="-"
                  disabled
                />
              </el-form-item>
              <el-form-item prop="socialExperience" label="实习经历">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5 }"
                  v-model="formData.socialExperience"
                  placeholder="-"
                  disabled
                />
              </el-form-item>
              <el-form-item prop="joinJob" label="是否缴纳过社会保险">
                <el-radio-group v-model="formData.joinJob" disabled>
                  <el-radio value="否">否</el-radio>
                  <el-radio value="是">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="residencePermitBegin" label="居住证起始日期">
                <el-date-picker v-model="formData.residencePermitBegin" disabled type="date" placeholder="-" />
              </el-form-item>
              <el-form-item prop="residencePermit" label="居住证截止日期">
                <el-date-picker v-model="formData.residencePermit" type="date" disabled placeholder="-" />
              </el-form-item>
              <el-form-item prop="remark" label="其他说明">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5 }"
                  v-model="formData.remark"
                  placeholder="-"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="fields-info">
        <el-divider content-position="left">额外信息填写</el-divider>
        <div class="content">
          <el-row :gutter="20">
            <template v-if="formData.otherFieldValue && formData.otherFieldValue.length > 0">
              <el-col :span="12" v-for="(item, index) in formData.otherFieldValue" :key="index">
                <el-form-item :label="item.name" class="field-item">
                  <template v-if="item.type !== 'image'">
                    <el-input v-model="item.value" disabled placeholder="-" />
                  </template>
                  <template v-else>
                    <el-image :src="item.value" fit="cover" style="width: 150px; height: 150px" />
                  </template>
                </el-form-item>
              </el-col>
            </template>
            <template v-else>
              <el-col :span="24">
                <el-empty description="暂无额外信息填写" :image-size="66" />
              </el-col>
            </template>
          </el-row>
        </div>
      </div>
      <div class="education-info">
        <el-divider content-position="left">教育经历</el-divider>
        <div class="content">
          <template v-if="formData.educations && formData.educations.length === 0">
            <el-empty description="暂无教育经历" :image-size="66" />
          </template>
          <template v-else>
            <div class="education-item" v-for="(item, index) in formData.educations" :key="index">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="schoolName" label="学校名称">
                    <el-input v-model="item.schoolName"  placeholder="-" disabled />
                  </el-form-item>
                  <el-form-item prop="professional" label="所学专业">
                    <el-input v-model="item.professional" placeholder="-" disabled />
                  </el-form-item>
                  <el-form-item prop="education" label="学历">
                    <el-input v-model="formData.education" disabled placeholder="-" />
                    <!-- <el-select v-model="item.education" placeholder="-" style="width: 240px" disabled>
                      <el-option v-for="(item, index) in educationOptions" :key="index" :label="item" :value="item" />
                    </el-select> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="graduate" label="是否毕业">
                    <el-radio-group v-model="item.graduate" disabled>
                      <el-radio value="已毕业">已毕业</el-radio>
                      <el-radio value="未毕业">未毕业</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item prop="educationDateRange" label="教育时间">
                    <el-date-picker
                      v-model="item.educationDateRange"
                      type="monthrange"
                      range-separator="-"
                      start-placeholder="-"
                      end-placeholder="-"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </template>
        </div>
      </div>
      <div class="family-info">
        <el-divider content-position="left">家庭信息</el-divider>
        <div class="content">
          <template v-if="formData.familyMembers && formData.familyMembers.length === 0">
            <el-empty description="暂无家庭信息" :image-size="66" />
          </template>
          <template v-else>
            <div class="family-item" v-for="(item, index) in formData.familyMembers" :key="index">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="appellation" label="称谓">
                    <el-input v-model="item.appellation" disabled placeholder="-" disabled />
                  </el-form-item>
                  <el-form-item prop="name" label="姓名">
                    <el-input v-model="item.realName" disabled placeholder="-" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="name" label="职务">
                    <el-input v-model="item.position" disabled placeholder="-" disabled />
                  </el-form-item>
                  <el-form-item prop="name" label="单位名称">
                    <el-input v-model="item.companyName"  disabled placeholder="-" disabled />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </template>
        </div>
      </div>
      <div class="internship-info">
        <el-divider content-position="left">实习经历</el-divider>
        <div class="content">
          <template v-if="formData.internshipExperiences && formData.internshipExperiences.length === 0">
            <el-empty description="暂无实习经历" :image-size="66" />
          </template>
          <template v-else>
            <div class="internship-item" v-for="(item, index) in formData.internshipExperiences" :key="index">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="name" label="单位名称">
                    <el-input v-model="item.name" disabled placeholder="-" disabled />
                  </el-form-item>
                  <el-form-item prop="remark" label="工作描述">
                    <el-input type="textarea" :rows="3" disabled v-model="item.remark" placeholder="-" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="internshipDateRange" label="工作时间">
                    <el-date-picker
                      v-model="item.internshipDateRange"
                      type="monthrange"
                      range-separator="-"
                      start-placeholder="-"
                      end-placeholder="-"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </template>
        </div>
      </div>
      <div class="work-info">
        <el-divider content-position="left">工作经历</el-divider>
        <div class="content">
          <template v-if="formData.workExperiences && formData.workExperiences.length === 0">
            <el-empty description="暂无工作经历" :image-size="66" />
          </template>
          <template v-else>
            <div class="work-item" v-for="(item, index) in formData.workExperiences" :key="index">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="companyName" label="单位名称">
                    <el-input v-model="item.companyName" disabled placeholder="-" disabled />
                  </el-form-item>
                  <el-form-item prop="department" label="所在部门">
                    <el-input v-model="item.department" disabled placeholder="-" disabled />
                  </el-form-item>
                  <el-form-item prop="positionName" label="岗位名称">
                    <el-input v-model="item.positionName" disabled placeholder="-" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="companyIndustry" label="企业性质">
                    <el-input v-model="formData.companyIndustry" disabled placeholder="-" />
                    <!-- <el-select v-model="item.companyIndustry" placeholder="-" style="width: 240px" disabled>
                      <el-option v-for="(item, index) in educationOptions" :key="index" :label="item" :value="item" />
                    </el-select> -->
                  </el-form-item>
                  <el-form-item prop="workDateRange" label="工作时间">
                    <el-date-picker
                      v-model="item.workDateRange"
                      type="monthrange"
                      range-separator="-"
                      start-placeholder="-"
                      end-placeholder="-"
                      disabled
                    />
                  </el-form-item>
                  <el-form-item prop="workDesc" label="工作描述">
                    <el-input type="textarea" :rows="3" disabled v-model="item.workDesc" placeholder="-" disabled />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </template>
        </div>
      </div>
      <div class="qualification-info">
        <el-divider content-position="left">资质及职业职称</el-divider>
        <div class="content">
          <template v-if="formData.qualifications && formData.qualifications.length === 0">
            <el-empty description="暂无资质及职业职称" :image-size="66" />
          </template>
          <template v-else>
            <div class="qualification-item" v-for="(item, index) in formData.qualifications" :key="index">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="postion" label="职业资格">
                    <el-input v-model="item.postion" disabled placeholder="-" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="getTime" label="获得时间">
                    <el-date-picker v-model="item.getTime" disabled type="date" placeholder="-" disabled />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </template>
        </div>
      </div>
      <div class="document-info">
        <el-divider content-position="left">电子文件</el-divider>
        <div class="content">
          <template v-if="formData.documents && formData.documents.length === 0">
            <el-empty description="暂无电子文件" :image-size="66" />
          </template>
          <template v-else>
            <el-row :gutter="20" v-if="formData.documents">
              <el-col :span="12" v-if="formData.documents.idCardFront">
                <el-form-item prop="idCardFront" label="身份证正面" label-position="top">
                  <el-image
                    :src="formData.documents.idCardFront"
                    :preview-src-list="[formData.documents.idCardFront]"
                    fit="contain"
                    style="width: 300px; height: 200px"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.documents.idCardReverse">
                <el-form-item prop="idCardReverse" label="身份证反面" label-position="top">
                  <el-image
                    :src="formData.documents.idCardReverse"
                    :preview-src-list="[formData.documents.idCardReverse]"
                    fit="contain"
                    style="width: 300px; height: 200px"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="isEmptyArray('certificatePdfs') || isEmptyArray('certificateImages')">
                <el-form-item prop="certificateImage" label="最高学历、学位证明" label-position="top">
                  <div v-if="isEmptyArray('certificatePdfs')">
                    <div
                      v-for="(item, index) in formData.documents.certificatePdfs"
                      :key="index"
                      style="margin-bottom: 5px"
                    >
                      <el-button type="primary" @click="handlePreviewPdf(item)">点击预览PDF</el-button>
                    </div>
                  </div>
                  <div v-if="isEmptyArray('certificateImages')">
                    <el-carousel
                      class="image-swiper"
                      indicator-position="outside"
                      arrow="always"
                      height="200px"
                      style="width: 300px"
                    >
                      <el-carousel-item v-for="(item, index) in formData.documents.certificateImage" :key="index">
                        <el-image
                          style="width: 100%; height: 100%"
                          :src="item"
                          :preview-src-list="formData.documents.certificateImage"
                          :preview-teleported="true"
                          :initial-index="index"
                          :fit="'contain'"
                        />
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.documents.studentStatus">
                <el-form-item prop="studentStatus" label="学籍证明" label-position="top">
                  <template v-if="isUrlType('.pdf', formData.documents.studentStatus)">
                    <el-button type="primary" @click="handlePreviewPdf(formData.documents.studentStatus)">
                      点击预览PDF
                    </el-button>
                  </template>
                  <template v-else>
                    <el-image
                      :src="formData.documents.studentStatus"
                      :preview-src-list="[formData.documents.studentStatus]"
                      fit="contain"
                      style="width: 300px; height: 200px"
                    />
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.documents.residencePermitImage">
                <el-form-item prop="residencePermitImage" label="居住证" label-position="top">
                  <el-image
                    :src="formData.documents.residencePermitImage"
                    :preview-src-list="[formData.documents.residencePermitImage]"
                    fit="contain"
                    style="width: 300px; height: 200px"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.documents.technicalImage">
                <el-form-item prop="technicalImage" label="专业技术职称（资格）" label-position="top">
                  <el-carousel
                    class="image-swiper"
                    indicator-position="outside"
                    arrow="always"
                    height="200px"
                    style="width: 300px"
                  >
                    <el-carousel-item v-for="(item, index) in formData.documents.technicalImage" :key="index">
                      <el-image
                        style="width: 100%; height: 100%"
                        :src="item"
                        :preview-src-list="formData.documents.technicalImage"
                        :preview-teleported="true"
                        :initial-index="index"
                        :fit="'contain'"
                      />
                    </el-carousel-item>
                  </el-carousel>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.documents.qualificationImage">
                <el-form-item prop="qualificationImage" label="职业资格" label-position="top">
                  <el-carousel
                    class="image-swiper"
                    indicator-position="outside"
                    arrow="always"
                    height="200px"
                    style="width: 300px"
                  >
                    <el-carousel-item v-for="(item, index) in formData.documents.qualificationImage" :key="index">
                      <el-image
                        style="width: 100%; height: 100%"
                        :src="item"
                        :preview-src-list="formData.documents.qualificationImage"
                        :preview-teleported="true"
                        :initial-index="index"
                        :fit="'contain'"
                      />
                    </el-carousel-item>
                  </el-carousel>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.documents.others">
                <el-form-item prop="others" label="其他" label-position="top">
                  <el-carousel
                    class="image-swiper"
                    indicator-position="outside"
                    arrow="always"
                    height="200px"
                    style="width: 300px"
                  >
                    <el-carousel-item v-for="(item, index) in formData.documents.others" :key="index">
                      <el-image
                        style="width: 100%; height: 100%"
                        :src="item"
                        :preview-src-list="formData.documents.others"
                        :preview-teleported="true"
                        :initial-index="index"
                        :fit="'contain'"
                      />
                    </el-carousel-item>
                  </el-carousel>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.documents.portfolio">
                <el-form-item prop="portfolio" label="作品集" label-position="top">
                  <el-button type="primary" @click="handlePreviewPdf(formData.documents.portfolio)">
                    点击预览PDF
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-empty v-else description="暂无电子文件" :image-size="66" />
          </template>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "PersonResume",
  props: {
    resumeData: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      handleLoading: false,
      visible: false,
      formDataRef: null,
      formData: {
        id: "",
        realName: "",
        sex: "",
        headImage: "",
        idNum: "",
        age: "",
        birthday: "",
        nation: "",
        navitePlace: "",
        navite: "",
        liveCity: "",
        maritalStatus: "",
        politic: "",
        email: "",
        phoneNum: "",
        score: "",
        education: "",
        educationType: "",
        freshStudent: "",
        rewardPunish: "",
        socialExperience: "",
        joinJob: "",
        wordYear: "",
        wordStatus: "",
        health: "",
        position: "",
        residencePermitBegin: "",
        residencePermitEnd: "",
        residencePermit: "",
        remark: "",
        educations: [],
        familyMembers: [],
        internshipExperiences: [],
        workExperiences: [],
        qualifications: [],
        documents: {},
        recordStatus: "",
        isNotice: "",
        otherFieldValue: []
      },
      formRules: {},
      dialogTitle: "个人简历",
      recordId: "",
      printHtml: "",
      // educationOptions,
      // educationTypeOptions,
      // politicOptions,
      // nationOptions,
      // regionOptions
    }
  },
  watch: {
    resumeData: {
      handler(newVal) {
        if(newVal){
          this.handleResumeData(newVal);
          console.log('处理后的formData:', this.formData);
        }
      },
      immediate: true,
      deep: true
    },
    loading(newVal) {
      this.loading = newVal;
    }
  },
  mounted() {
    // 确保组件挂载后对话框可见
    this.visible = true;

    // 如果已有resumeData数据，确保处理一次
    if (this.resumeData && Object.keys(this.resumeData).length > 0) {
      this.handleResumeData(this.resumeData);
    }
  },
  methods: {
    init(id) {
      this.visible = true;
      this.$nextTick(() => {
        this.recordId = id;
        // 确保对话框显示后再处理数据
        if (this.resumeData && Object.keys(this.resumeData).length > 0) {
          this.handleResumeData(this.resumeData);
        }
      });
    },
    handleResumeData(resumeData) {
      // 确保 resumeData 不为空
      // console.log(resumeData)
      if (!resumeData || typeof resumeData !== 'object') {
        console.warn('resumeData 无效:', resumeData);
        return;
      }

      // 处理从父组件传递过来的数据
      Object.keys(resumeData).forEach(key => {
        if (key in this.formData) {
          this.formData[key] = resumeData[key]
        }
      })
      // educationOptions = resumeData.education;
      // educationTypeOptions = resumeData.educationType;
      // politicOptions = resumeData.politic;
      // nationOptions = resumeData.nation;

      // 处理教育经历日期范围
      if (resumeData.educations && Array.isArray(resumeData.educations)) {
        this.formData.educations = resumeData.educations.map(item => {
          return {
            ...item,
            educationDateRange: [item.startDate, this.translateToday(item.endDate)]
          }
        })
      }

      // 处理工作经历日期范围
      if (resumeData.workExperiences && Array.isArray(resumeData.workExperiences)) {
        this.formData.workExperiences = resumeData.workExperiences.map(item => {
          return {
            ...item,
            workDateRange: [item.startDate, this.translateToday(item.endDate)]
          }
        })
      }

      // 处理实习经历日期范围
      if (resumeData.internshipExperiences && Array.isArray(resumeData.internshipExperiences)) {
        this.formData.internshipExperiences = resumeData.internshipExperiences.map(item => {
          return {
            ...item,
            internshipDateRange: [item.startTime, this.translateToday(item.endTime)]
          }
        })
      }

      // 处理其他字段值
      if (resumeData.otherFieldValue && typeof resumeData.otherFieldValue === 'string') {
        this.formData.otherFieldValue = JSON.parse(resumeData.otherFieldValue)
      } else if (resumeData.otherFieldValue) {
        this.formData.otherFieldValue = resumeData.otherFieldValue
      }

      // 处理证书图片和PDF
      if (resumeData.documents) {
        this.formData.documents = resumeData.documents
        this.formData.documents.certificateImages = []
        this.formData.documents.certificatePdfs = []

        if (this.formData.documents.certificateImage && this.formData.documents.certificateImage.length > 0) {
          this.formData.documents.certificateImage.forEach(item => {
            if (this.isUrlType(".pdf", item)) {
              this.formData.documents.certificatePdfs.push(item)
            } else if (this.isUrlType(".jpg", item) || this.isUrlType(".png", item)) {
              this.formData.documents.certificateImages.push(item)
            }
          })
        }
      }

    },
    // 重置表单
    handleClose() {
      this.$refs.formDataRef.resetFields()
      this.$emit("refreshDataList")
    },
    translateToday(time) {
      // 如果time是"至今"，则返回当前年月
      if (time === "至今") {
        const now = new Date()
        return `${now.getFullYear()}-${now.getMonth() + 1}`
      } else {
        return time
      }
    },
    isEmptyArray(item) {
      if (this.formData.documents[item] && this.formData.documents[item].length > 0) {
        return true
      } else {
        return false
      }
    },
    isUrlType(type, url) {
      if (url.indexOf(type) !== -1) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.el-radio.is-disabled .el-radio__label {
  color: #000 !important;
}
.resume-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.deliver-record {
  display: flex;
}
.el-divider--horizontal {
  margin: 16px 0 24px 0;
}
.el-divider__text {
  font-size: 16px;
}
.input-container-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin: 30px 0;
}
.el-empty {
  --el-empty-padding: 0 0;
}
.input-operation {
  text-align: center;
  margin-top: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: space-between;
}

.document-info .content {
  padding-left: 70px;
}
.field-item .el-form-item__label {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.dialog_ .el-dialog__body {
  height: 670px;
  overflow-y: auto; /* 只允许垂直方向滚动 */
  overflow-x: hidden; /* 禁止水平方向滚动 */
}
.dialog_ {
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PersonResume.vue